import App from 'app/app.js';
import 'app/directive/LtAddonCarouselCtrl.js';

function LtAddonCarouselDirective() {
  return {
    restrict: 'E',
    scope: {
      addons: '=',
      confirm: '&'
    },
    template:
      '<div id="carousel-cart-look" class="carousel slide look-carousel" ng-init="addonCarousel.init()">' +
      '   <div class="carousel-container">' +
      '       <div class="control control-left" ng-click="addonCarousel.prevPage()" data-test-carousel-previous>' +
      '           <lt-icon name="fa-sharp-solid-chevron-left" class="carousel-size" aria-hidden="true"></lt-icon>' +
      '       </div>' +
      '       <div class="control control-right" ng-click="addonCarousel.nextPage()" data-test-carousel-next>' +
      '           <lt-icon name="fa-sharp-solid-chevron-right" class="carousel-size" aria-hidden="true"></lt-icon>' +
      '       </div>' +
      '       <div id="carousel-body" class="carousel-body">' +
      '           <div id="chunked-item--{{key}}" class="chunked-item" ng-repeat="(key, rowLook) in addonCarousel.chunkedAddons">' +
      '               <div class="item" ng-repeat="(key, colLook) in rowLook" >' +
      '                   <h6 ng-bind="colLook.item | ItemDescFilter"></h6>' +
      '                   <div class="carousel-addon-sheet">' +
      '                      <img alt="current-portrait" ng-src="{{colLook.image}}" class="image"/> ' +
      '                   </div>' +
      '                   <a class="btn lt-btn" lt-translate="CYOP_CHOOSE" ng-click="addonCarousel.selectItem(colLook)" data-test-choose-cyop-item-btn ></a>' +
      '               </div>' +
      '           </div>' +
      '       </div>' +
      '         <ol class="carousel-indicators">' +
      '                <li ng-repeat="(key, value) in addonCarousel.chunkedAddons" ng-click="addonCarousel.indicatorScroll(key)" class="pagination" ng-class="{active: key === addonCarousel.pageIndex}"></li>' +
      '         </ol>' +
      '   </div> ' +
      '</div>',
    controller: 'LtAddonCarouselCtrl',
    controllerAs: 'addonCarousel'
  };
}

App.directive('ltAddonCarousel', [LtAddonCarouselDirective]);
